import { ConsignmentDetail } from '../../consignment-detail/models/types'
import { HouseConsignment } from '../models/types'
import { HouseConsignmentFormSaveResult } from './useHouseConsignmentForm'

export interface HouseConsignmentFormHandle {
  save: () => Promise<HouseConsignmentFormSaveResult>
  isDirty: () => boolean
}

export type HouseConsignmentRowData = {
  id: number
  sequenceNumber: number
  consignee?: ConsignmentDetail | null
  consignor?: ConsignmentDetail | null
  seller?: ConsignmentDetail | null
  buyer?: ConsignmentDetail | null
  grossMass: number
  numberOfGoods: number
  invalidCommodityData: boolean
}

export function mapHouseConsignmentToRowData(hc: HouseConsignment): HouseConsignmentRowData {
  return {
    id: hc.id,
    sequenceNumber: hc.sequenceNumber,
    consignee: hc.consignee,
    consignor: hc.consignor,
    buyer: hc.buyer,
    seller: hc.seller,
    grossMass: hc.grossMass,
    numberOfGoods: hc.numberOfGoods,
    invalidCommodityData: hc.invalidCommodityCode,
  }
}
